export const WatchLaterLearningContentTypeMap = {
  LESSON: 'LESSON',
  TRACK: 'TRACK',
  SHORT: 'SHORT_FORM_CONTENT'
};